<template>
  <div class="tags-editor">
    <el-tag
      v-for="tag in value"
      :key="tag"
      :closable="true"
      :close-transition="false"
      type="primary"
      @close="handleClose(tag)"
    >
      <slot :tag="tag">
        {{ tag }}
      </slot>
    </el-tag>
    <el-input
      v-if="(inputVisible || inputAlwaysVisible) && !options.length"
      ref="saveTagInput"
      v-model="inputValue"
      class="input-new-tag"
      size="mini"
      @keyup.enter.native="handleInputConfirm"
      @keyup.escape.native="hideInput"
      @keydown.comma.native.capture.prevent.stop="handleInputConfirm"
      @keydown.escape.native.capture.prevent.stop
      @blur="handleInputConfirm"
    />
    <el-select
      v-else-if="(inputVisible || inputAlwaysVisible) && options.length"
      ref="optionsSelect"
      class="input-new-tag"
      filterable
      :value="optionInputValue"
      @input="onOptionSelected"
      @visible-change="onSelectVisibleChange"
      @keyup.escape.native="hideInput"
    >
      <el-option
        v-for="option in options.filter((opt) => !value.includes(opt.value))"
        :key="option.value"
        :label="option.label"
        :value="option.value"
      />
    </el-select>
    <el-button
      v-else
      v-show="allowToAddTags"
      class="button-new-tag"
      size="small"
      @click="showInput"
    >
      + {{ newTagLabel }}
    </el-button>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Array },
    newTagLabel: { type: String, default: 'New tag' },
    validator: { type: Function, default: null },
    options: { type: Array, default: () => [] },
    allowToAddTags: { type: Boolean, default: true },
    inputAlwaysVisible: { type: Boolean, default: false },
  },
  data() {
    return {
      inputVisible: false,
      inputValue: '',
      optionInputValue: '',
    }
  },
  methods: {
    handleClose(tag) {
      const newTags = this.value.filter((t) => t !== tag)
      this.$emit('change', newTags)
      // this.value.splice(this.value.indexOf(tag), 1);
    },

    showInput() {
      this.inputVisible = true
      this.$nextTick(() => {
        if (this.$refs.saveTagInput) {
          this.$refs.saveTagInput.$refs.input.focus()
        } else if (this.$refs.optionsSelect) {
          this.$refs.optionsSelect.focus()
        }
      })
    },

    hideInput(event) {
      this.inputVisible = false
      this.inputValue = ''
    },

    handleInputConfirm() {
      const inputValue = this.inputValue
      if (!this.isValid()) {
        this.$emit('invalid-input', this.inputValue)
        return
      }
      if (inputValue) {
        this.emitNewTags(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },

    emitNewTags(newTag) {
      const newTags = this.value.concat(newTag)
      this.$emit('change', newTags)
    },

    isValid() {
      const inputValue = this.inputValue
      if (this.validator && !this.validator(inputValue)) {
        return false
      } else {
        return true
      }
    },

    onOptionSelected(optionValue) {
      if (optionValue) {
        this.emitNewTags(optionValue)
      }
      this.hideInput()
    },

    onSelectVisibleChange(isVisible) {
      console.log(' => is select dropdown visible:', isVisible)
      if (!isVisible) {
        setTimeout(this.hideInput, 50)
      }
    },
    onKeydown(e) {
      console.log(' => onKeydown', e.key, e.code, e)
    },
  },
}
</script>

<style lang="scss" scoped>
.input-new-tag {
  margin-top: 2px;
  width: 78px;
}

.el-tag {
  margin-left: 0px;
  margin-right: 5px;
  margin-bottom: 5px;
}
</style>
